<div (click)="customizeLayoutDark()" class="mode" ngbTooltip="Mode">
   <i class="ri-moon-line"></i>
</div>